import { SiteDictionary } from '@/lib/dictionary';

const ru: SiteDictionary = {
  generic: {
    actions: {
      scrollLeft: 'Прокрутите влево',
      scrollRight: 'Прокрутите вправо',
      goBack: 'Назад',
      close: 'Закрыть',
      addBookmark: 'Сохранить',
      removeBookmark: 'Сохранено в закладки',
      showLess: 'Показать меньше',
      showMore: 'Показать больше',
      openPDF: 'Открыть PDF файл',
      openMenu: 'Открыть меню',
      scrollToTop: 'Вернуться наверх',
      listenTranscription: 'Прослушать статью',
      share: 'Поделиться',
      remove: 'Удалить все',
      show: 'Показать',
      filter: 'Фильтровать',
      closeMessage: 'Закрыть уведомление',
    },
  },
  components: {
    menu: {
      campaign: 'Кампания!',
      servicesAndProducts: 'Услуги',
      backgroundInformation: 'Кредитная информация',
      debtRegister: 'Реестр должников',
      marketReview: 'Обзоры рынка',
      marketingLists: 'Маркетинговые списки',
      salesAgent: 'Торговый агент',
      certificates: 'Сертификаты',
      api: 'Интеграции данных',
      pricingPackages: 'Тарифы',
      blog: 'Блог',
      aboutUs: 'О нас',
      contact: 'Контакты',
      termsOfService: 'Условия использования',
      consultation: 'Хотите бесплатную консультацию и демо Инфобанка?',
      booking: 'Забронировать',
    },
    intro: {
      title: 'Всё об эстонских компаниях',
      creditInformation: 'Кредитная информация',
      debtRegister: 'Реестр должников',
      marketingLists: 'Маркетинговые списки',
      salesAgent: 'Торговый агент',
      marketReviews: 'Обзоры рынка',
      certificates: 'Сертификаты',
      dataIntegration: 'Интеграции данных',
    },
    hero: {
      author: 'Автор',
      authors: 'Авторы',
    },
    search: {
      startSearch: 'Искать',
      placeholder: 'Найти компанию или человека',
      clearFields: 'Очистить поиск',
      companies: 'Компании',
      persons: 'Имена',
      all: 'Все',
      articles: 'Статьи',
      result: ' результаты поиска',
      description:
        'Внимание! Отображается до 10,000 результатов. Пожалуйста, уточните выбор фильтров. Файл содержит до 10,000 записей. Пожалуйста, уточните выбор фильтров. Данные включают: имя человека, дату рождения, пол, контактные данные, название связанной компании, регистрационный код, сферу деятельности, контактные данные компании, доход, операционную прибыль и количество сотрудников',
      sendRequest: 'Отправить запрос',
      viewFileExample: 'Посмотреть образец (.xlsx)',
      noPersonResults: '0 результатов по запросу человека {{query}} ... выполните новый поиск!',
      noCompanyResults: '0 результатов по запросу компании {{query}} ... выполните новый поиск!',
      companyName: 'Название компании',
      registrationCode: 'Регистрационный код',
      headerResults: 'результаты поиска',
      backToSearch: 'Вернуться к результатам поиска',
      formerName: 'прежнее имя',
    },
    header: {
      login: 'Войти',
      logout: 'Выйти',
    },
    footer: {
      findUs: 'Найдите нас {{label}}',
    },
    applicationForm: {
      title: 'Форма подачи заявления',
      firstname: 'Имя',
      surname: 'Фамилия',
      phone: 'Телефон',
      email: 'Электронная почта',
      message: 'Сообщение (мотивационное письмо)',
      addCv: 'Добавить резюме (docx, PDF)',
      cancel: 'Отменить',
      send: 'Отправить',
      required: 'Обязательно',
      success: 'Заявка отправлена',
      close: 'Закрыть уведомление',
      addFiles: 'Добавить файлы',
    },
    askOffer: {
      close: 'Закрыть уведомление',
      send: 'Предложение по золотому пакету отправлено',
      title: 'Пожалуйста, оставьте свои контактные данные, мы свяжемся с вами в ближайшее время',
      subtitle: 'В пробный период включена бесплатная демо-версия Инфобанка, чтобы вы могли получить от нее максимальную пользу.',
      success: 'Ваш запрос был отправлен нам!',
      error: 'Произошла ошибка при отправке данных. Пожалуйста, проверьте поля.',
      name: 'Имя и фамилия',
      required: 'Обязательно',
      phone: 'Телефон',
      email: 'Электронная почта',
      info: 'Интересующая тема',
      message: 'Сообщение',
      button: 'Отправить',
      options: {
        credit: 'Кредитная информация',
        marketing: 'Маркетинговые списки',
        other: 'Другое',
        select: 'Выберите категорию',
      },
      validation: {
        wrongPhone: 'Недопустимый номер',
        wrongPhoneNumber: 'Только цифры',
        wrongEmail: 'Неверный формат электронной почты',
      },
    },
    breadcrumbs: {
      frontpage: 'Главная страница',
      search: 'Поиск',
      blog: 'Блог',
      account: 'Аккаунт',
    },
    article: {
      readMore: 'Читать дальше',
    },
    controlMulti: {
      selectCategory: 'Выбрать все в категории',
    },
    companyChart: {
      allFilters: 'Все фильтры',
      showSecondStageRelations: 'Показать связи второго уровня',
      applyFilters: 'Применить фильтры',
      showBeneficiaries: 'Показать выгодополучателей',
    },
    notFound: {
      title: 'Страница не найдена',
      description: 'Страница, которую вы ищете, больше недоступна',
      back: 'Перейти на главную страницу',
    },
    error: {
      title: 'Что-то пошло не так',
      description: 'Не удалось выполнить действие. Пожалуйста, попробуйте снова через мгновение.',
    },
    serverError: {
      title: 'Что-то пошло не так',
      description: 'При загрузке страницы произошла непредвиденная ошибка. Пожалуйста, повторите попытку позже.',
    },
    moduleError: {
      title: 'Что-то пошло не так',
      description: 'При загрузке модуля произошла непредвиденная ошибка. Пожалуйста, повторите попытку позже.',
    },
    table: {
      showHistory: 'Показать историю',
      hideHistory: 'Скрыть историю',
    },
    paywall: {
      text: 'Чтобы загрузить кредитный отчет, вам нужно войти в систему как пользователь Золотого пакета',
      addDebt: 'Чтобы добавить долговое требование, вам нужно войти в систему как пользователь Золотого пакета',
      monitoring: 'Чтобы добавить компанию в мониторинг, вам нужно войти в систему как пользователь Золотого пакета',
      limitMonitoring:
        'Ваш список мониторинга заполнен. Если вам нужно увеличить лимит, сообщите нам на <a href="mailto:info@infopank.ee">info@infopank.ee</a>',
      downloadLimit:
        'Ваш лимит загрузок на этот месяц исчерпан. Если вы хотите изменить лимиты, напишите нам на <a href="mailto:info@infopank.ee">info@infopank.ee</a>',
      button: 'Активировать золотой пакет',
    },
    blog: {
      title: 'Блог',
      button: 'Посмотреть все записи блога',
    },
    share: {
      email: 'Электронная почта',
      link: 'Ссылка',
    },
  },
  company: {
    dataNotLoaded: 'Ошибка при загрузке данных',
    tryAgain: 'Попробуйте еще раз',
    addDebt: 'Добавить долг',
    creditReport: 'Кредитный отчет',
    creditReportExample: 'Посмотреть пример отчета',
    removeMonitoring: 'Удалить из мониторинга',
    addMonitoring: 'Добавить в мониторинг',
    success: 'Готово!',
    removed: 'Компания удалена из мониторинга',
    added: 'Компания добавлена в мониторинг',
    news: 'Новости',
    articleNews: 'Информационные сообщения',
    noNews: 'Предприятие не представлено в новостях Äripäev',
    sections: {
      'general': 'Общая информация',
      'business-relations': 'Деловые связи',
      'business-analytics': 'Бизнес-аналитика',
      'swot-analysis': 'SWOT-анализ',
      'tax-report': 'Налоговый отчет',
      'debt-registry': 'Реестр задолженностей',
      'other-info': 'Другая информация',
    },
    pdf: {
      view: 'Смотреть',
      download: 'Открыть',
    },
    chart: {
      connectionsLimit: 'Слишком много деловых связей для построения графика. Пожалуйста, скорректируйте условия.',
    },
    businessAnalyticsComparison: {
      subtitle: 'Сравните финансовые показатели компании с другими выбранными компаниями.',
      compareWith: 'Сравнить с компанией',
      searchPlaceholder: 'Поиск компании',
      inComparison: 'В сравнении',
      clearComparison: 'Очистить сравнение',
      removeFromComparison: 'Удалить {{name}} из сравнения',
      mainCompanyBadge: 'Основная компания',
      quarterlyRevenue: 'Квартальный оборот',
      employeeCount: 'Количество работников',
      revenuePerEmployee: 'Оборот на одного работника',
      averageMonthlyWage: 'Средняя месячная зарплата',
      loadingComparisonData: 'Загрузка данных для сравнения...',
    },
    download: {
      result: '{{total}} результаты поиска',
      description:
        'Внимание! Отображается до {{maxRowsInExport}} результатов. Пожалуйста, уточните выбор фильтров. Файл содержит до {{maxRowsInExport}} записей. Пожалуйста, уточните выбор фильтров.',
      limit: 'Внимание! Для загрузки файлов необходимо включить всплывающие окна в браузере! Лимит файлов: {{limit}} Остаток: {{stock}}',
      save: 'Сохранить результаты (.csv)',
    },
    filter: {
      personAudience: 'Целевая группа ключевых лиц',
      companyAudience: 'Целевая группа компаний',
      relatedToPerson: 'Фильтры для компаний, связанных с лицом',
      listOfCompanies: 'Создать список компаний',
      viewAll: 'Выбрать все',
      keyPerson: 'Фильтры ключевых лиц',
      relationship: 'Связь с компанией',
      areaResponsibility: 'Сфера ответственности',
      belongs: 'Принадлежность к бизнес-рейтингам',
      numberEmployee: 'Количество сотрудников',
      from: 'От',
      to: 'До',
      location: 'Местоположение',
      establishDate: 'Дата создания',
      legalForm: 'Юридическая форма компании',
      profitLoss: 'Операционная прибыль/убыток',
      fieldActivity: 'Сфера деятельности',
      searchFieldActivity: 'Введите желаемую сферу деятельности',
      revenue: 'Доход',
    },
    creditReportComponent: {
      description:
        '<p>Кредитный отчет включает следующую информацию и доступен для печати:</p><ul><li>Кредитный рейтинг и рекомендуемый кредитный лимит</li><li>Информация о задолженностях: налоговые долги, требования в реестре долгов Infopank, платежные приказы, уведомления об исполнении, арест имущества</li><li>Общая информация о компании, контактные данные</li><li>Ответственные лица (правление)</li><li>Другие связанные лица (владельцы, члены наблюдательного совета, основатель, аудитор, ключевые сотрудники)</li><li>Баланс, отчет о прибыли и убытках, отчет о движении денежных средств из последнего доступного годового отчета</li><li>Квартальные финансовые результаты: выручка, количество сотрудников, уплаченные налоги</li><li>Связанные новости и включение в рейтинги Äripäev</li></ul><p>Отчет создается в режиме реального времени на основе самых актуальных данных. Пожалуйста, проявите терпение, так как создание отчета может занять несколько секунд.</p>',
    },
  },
  person: {
    noNews: 'Лицо не встречается в новостях Äripäev',
    sections: {
      'overview': 'Информационная карта',
      'business-relations': 'Деловые связи',
      'work-history': 'Трудовая деятельность',
      'news': 'Новости',
    },
    table: {
      name: 'Имя',
      birthday: 'Дата рождения',
    },
  },
  account: {
    myAccount: 'Мой аккаунт',
    monitoringCompanyList: 'Отслеживаемые компании',
    monitoringEvents: 'События мониторинга',
    companyName: 'Название компании',
    selfService: 'Самообслуживание',
    selfServiceDescription:
      'В бизнес-самообслуживании вы можете редактировать информацию об аккаунте, управлять заказами, добавлять/удалять доступ и т. д.',
    selfServiceButton: 'Войти в самообслуживание',
    noMonitoringEventsTitle: 'Нет событий!',
    noMonitoringEventsDescription:
      'После того как вы добавите в мониторинг своих важных конкурентов, клиентов и партнеров, здесь вы найдете свежие уведомления о этих компаниях в будущем. Уведомления о мониторинге также будут отправляться на вашу электронную почту. Чтобы добавить компанию в мониторинг, нажмите кнопку «Добавить в мониторинг» в карточке компании.',
  },
  toaster: {
    success: 'Готово!',
    companyDeleted: 'Компания удалена из мониторинга',
    ip: 'Вы находитесь в сети {{name}} с правом чтения. Пожалуйста, войдите, чтобы получить полный доступ.',
    login: 'Войти',
  },
  debtForm: {
    conditions: 'Согласитесь с условиями',
    details: 'Данные кредитора',
    error: 'Произошла ошибка при отправке данных. Пожалуйста, проверьте поля.',
    required: 'Обязательно',
    name: 'Имя кредитора',
    registerCode: 'Регистрационный код кредитора',
    contact: 'Контактное лицо кредитора',
    email: 'Электронная почта кредитора',
    phoneNumber: 'Телефон кредитора',
    debtDetails: 'Данные должника',
    debtName: 'Имя должника',
    debtRegisterCode: 'Регистрационный код должника',
    debtTime: 'Дата создания долга',
    debtTimeDescription: 'Внимание! Если долг состоит из нескольких счетов, например, используйте дату самого раннего счета.',
    debtSum: 'Сумма долга',
    debtDocuments: 'Подтверждающие документы',
    debtDocumentFormat: 'Допустимые форматы: {{formats}}',
    paymentInfo: 'ВАЖНО! Если долг погашен после добавления записи о задолженности, пожалуйста, сообщите нам по электронной почте.',
    paymentInfoSecond: 'Запись о задолженности будет отмечена как решенная в реестре.',
    agreement: {
      text: 'Я согласен с <1>условиями</1> публикации задолженностей и подтверждаю, что долг является взыскиваемым и не оспаривается.',
      terms: 'условиями',
    },
    cancel: 'Отменить',
    send: 'Отправить',
    addedDebt: 'Долг добавлен',
    debtDeny: 'Чтобы добавить долговое требование, вам нужно войти в систему как пользователь Золотого пакета',
    activatePackage: 'Активировать золотой пакет',
    paymentConditions: 'Условия публикации задолженностей',
    terms:
      '<p>Поставщик услуг – Äripäev AS</p><p>Клиент – лицо, желающее раскрыть задолженности своих клиентов.</p><p>Клиент имеет право вносить информацию о задолженностях своих клиентов в Инфобанк <a href="https://infopank.ee/">https://infopank.ee/</a> в соответствии с требованиями и правилами, установленными поставщиком услуг.</p><p>Платежный дефолт – это неисполнение клиентом финансового обязательства более чем через 30 (тридцать) дней после даты оплаты. Передавая информацию о задолженностях своих клиентов, клиент подтверждает, что внесенный платежный дефолт не оспаривается (отсутствуют споры), задолженность подлежит взысканию, а информация является достоверной.</p><p>Поставщик услуг имеет право отказать во внесении платежного дефолта. Перед публикацией платежного дефолта уведомление отправляется должнику по электронной почте. Через 7 дней должнику отправляется повторное уведомление о том, что платежный дефолт был опубликован.</p><p>Жалобы на точность данных должны быть поданы в письменной форме поставщику услуг, который передает соответствующую жалобу лицу, внесшему спорные данные. Лицо, внесшее спорные данные, обязано решить жалобу в течение 14 дней, уведомить заявителя жалобы в письменной форме и внести необходимые изменения в данные, если это необходимо. Поставщик услуг оставляет за собой право удалять данные, внесенные клиентом, если это обосновано.</p><p>Клиент несет ответственность за точность и законность предоставленных данных. Любой ущерб, вызванный распространением недостоверных данных, подлежит полному возмещению со стороны клиента.</p><p>Поставщик услуг имеет право в любое время ограничить или аннулировать право клиента вносить данные о платежных дефолтах своих клиентов/должников в Кредитный реестр.</p><p>Поставщик услуг оставляет за собой право вносить изменения в порядок внесения платежных дефолтов и, при необходимости, устанавливать дополнительные стандартные условия, которые будут опубликованы на сайте <a href="https://infopank.ee/">https://infopank.ee/</a> и которые в таком случае станут существенной частью соглашения и обязательными для клиента.</p>',
  },
  certificates: {
    congratulations: 'Поздравляем!',
    sorry: 'Результат проверки',
    backButton: 'Назад',
    qualifies: '{{companyName}} соответствует следующим сертификатам:',
    notQualifies: '{{companyName}} к сожалению, не соответствует сертификатам Инфобанка.',
    order: 'Заказать сертификаты',
    description: {
      html: '<p>Инфобанк выдает следующие сертификаты и знаки надежным, успешным и выдающимся компаниям:</p><ul><li>ТОП компания Äripäev</li><li>Надежная компания</li></ul>',
    },
    companyQualifies: 'Узнайте, соответствует ли ваша компания сертификату',
  },
  report: {
    extraDownload: {
      confirm: 'Я согласен',
      close: 'Закрыть',
      description:
        'Лимит {{maxAllowed}} бесплатной загрузки, установленный в вашем контракте, превышен. Каждая дополнительная загрузка стоит {{price}} евро. Плата будет добавлена к вашему ежемесячному счету.',
    },
  },
  cookie: {
    preferences: 'Управление настройками',
  },
};

export default ru;
